module.exports = __webpack_public_path__ + "img/logowhite.4deba134.png";